// extracted by mini-css-extract-plugin
module.exports = {"sidebarWrapper":"Sidebar_sidebarWrapper__1qcaH","sidebarActive":"Sidebar_sidebarActive__36eQZ","sideBarLinks":"Sidebar_sideBarLinks__23E6n"};